/* eslint-disable react-hooks/rules-of-hooks */
import styled from '@emotion/styled'
import { Tabs } from '@mui/material'
import { Colors, Shapes, Typographies, useTypography } from 'src/components/theme'

export const PillTabs = styled(Tabs)`
  height: max-content;
  width: max-content;
  min-height: auto;
  & .MuiTabs-indicator {
    display: none;
  }
  & .MuiTabs-flexContainer {
    gap: ${Shapes.spacing[2]}px;
  }
  & .MuiTab-root {
    height: auto;
    min-width: auto;
    min-height: auto;
    text-transform: none;
    color: ${Colors.textDark};
    ${useTypography(Typographies.textmd)}
    padding: ${Shapes.spacing[2]}px;
    border-radius: ${Shapes.borderRadius}px;
    background-color: ${Colors.bgMedium};
  }
  & .MuiTab-root.Mui-selected {
    background-color: ${({ color }) => color || Colors.blueDark};
    color: ${Colors.textWhite} !important;
    box-shadow: ${Colors.BOX_SHADOW};
  }

  & .MuiTab-root.Mui-disabled {
    color: ${Colors.textLight};
  }
`
